'use strict';

angular.module('ClinicApp').config(function($stateProvider, authorizationProvider) {
  $stateProvider.state('update-password', {
    url: '/update-password/:base64Email/:token/?redirectUrl',
    templateUrl: '/views/update-password.html',
    controller: 'UpdatePasswordCtrl',
    resolve: {
      pageTitle: function($pageTitle) {
        $pageTitle.set('Update Password - Opencare');
      },
      auth: authorizationProvider.requireUnauthorizedUser,
    },
    data: {
      hideNavigation: true,
    },
  });
});

angular.module('ClinicApp').controller('UpdatePasswordCtrl', function($scope, $q, $state, $timeout, $location, $stateParams, $base64, GrowlService, UserService, CurrentUser, OCAnalyticsUtil) {

  try {
    $scope.email = $base64.decode($stateParams.base64Email);
  } catch (_e) {
    GrowlService.error('The update password link specified was invalid.', {
      ttl: -1,
    });
    $state.go('login');
  }

  $scope.token = $stateParams.token;

  try {
    if ($stateParams.redirectUrl) {
      $scope.redirectUrl = decodeURIComponent($base64.decode($stateParams.redirectUrl));
    }
  } catch (_e) {
    // Do nothing for some reason...
  }

  $scope.submit = function() {
    if ($scope.password != $scope.confirmPassword) {
      GrowlService.error('Passwords provided do not match.');
      return $q.reject();
    }
    return UserService.submitResetPassword($scope.email, $scope.token, $scope.password)
      .then(() => {
        GrowlService.success('Your password has been successfully updated.');
        return UserService.login($scope.email, $scope.password);
      })
      .then(() => {
        return CurrentUser.update();
      })
      .then(() => {
        $timeout(() => {
          OCAnalyticsUtil.bootUserAnalytics();
          if ($scope.redirectUrl) {
            $location.url($scope.redirectUrl);
          } else {
            $state.go('home');
          }
        });
      })
      .catch(() => {
        GrowlService.error('Your password reset link may have expired if it has been more than 2 hours since you requested it.');
      });
  };

});
